<template>
  <div class="col-12 px-0">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="12" class="d-flex align-items-center">
            <div>
              {{ $lang.edit }}
              <strong
                v-text="
                  $route.name === 'profile' ? $lang.myProfile : $lang.person
                "
              ></strong>
              <span
                v-if="
                  pathOr(null, ['name'], personItem) &&
                  pathOr(null, ['family'], personItem)
                "
              >
                ({{ pathOr("", ["name"], personItem) }}
                {{ pathOr("", ["family"], personItem) }})</span
              >
            </div>
          </b-col>
        </b-row>
      </div>
      <LoadingSpinner :loading="tabLoading" />
      <b-card no-body v-if="!tabLoading">
        <b-tabs
          active-nav-item-class="font-weight-bold text-uppercase background-primary text-white"
          fill
        >
          <b-tab
            @click="activeTab(tabs_option.value)"
            v-for="(tabs_option, i) in tabs_options"
            :key="i"
            :title="tabs_option.text"
            :active="currentTab === tabs_option.value"
          >
            <LoadingSpinner :loading="isLoading" />
            <div v-if="!isLoading">
              <!-- show check box question to all -->
              <div
                v-if="
                  pathOr(false, ['show_check'], tabs_option) &&
                  isAdmin(tabPermissions, ['admin', 'edit'])
                "
                class="text-center"
              >
                <PersonHasData
                  :person_code="personCode"
                  :value="tabs_option.has_data"
                  :label="tabs_option.text"
                  :tabName="tabs_option.value"
                  :tabs_option="tabs_option"
                  @updateTab="updateTab"
                />
              </div>
              <div
                v-if="
                  pathOr(false, ['show_check'], tabs_option) &&
                  !isAdmin(tabPermissions, ['admin', 'edit'])
                "
                class="text-center"
              >
                <h4>{{ $lang.notExistParvandehInfoMessage }}</h4>
              </div>
              <div v-if="tabs_option && tabs_option.show_tabs">
                <b-alert
                  :show="
                    currentTab === 'uploadFile' &&
                    !!$lang.attachmentTabAlertMessage
                  "
                  variant="danger"
                  class="font-weight-bold"
                >
                  <i class="fas fa-info-circle fa-lg mr-2" />
                  <span v-html="$lang.attachmentTabAlertMessage" />
                </b-alert>
                <keep-alive>
                  <component
                    v-if="currentTab === tabs_option.value"
                    :is="tabs_option.value"
                    :showPermissionButton="showPermissionButton"
                    :parentPermissions="tabPermissions"
                    :item="personItem"
                    :personItem="personItem"
                    :code="personCode"
                    :keyServies="`person`"
                    :attachmentRoute="`attachment_person`"
                    :keyValue="personCode"
                    :file_types="file_types"
                    :allowCollapse="true"
                    :isCollapseFiles="true"
                    :parentAspectRatio="false"
                    :parentInitialAspectRatio="false"
                    :showFilePreview="showFilePreview"
                    :maxUploadFile="2048"
                    :allowFileSize="2048"
                    :hasEditTypeAttachment="true"
                    @getProfile="fetchData"
                    mode="personPage"
                  >
                  </component>
                </keep-alive>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
  </div>
</template>
<script>
import editPerson from "./editPerson";
import searchContact from "../contact/seatchContact";
import searchWorkExperience from "./../workExperions/searchWorkExperience";
import searchLicensePerson from "./../licensePerson/searchLicensePerson.vue";
import skillsPage from "./../skills/skillsPage";
import PersonHasData from "./personHasData";
import searchEducation from "./../education/searchEducation";
import searchArticels from "./../articels/searchArticels";
import searchSocialPerson from "./../social/searchSocialPerson";
import searchAddress from "../address/searchAddress";
import searchPersonCompany from "./../person_company/searchPersonCompany";
import uploadFile from "@/components/base/uploadFile";
import otherPersonPage from "./../otherPersonInformation/otherPersonPage";
import searchPersonExam from "./../personExam/searchPersonExam";
import searchFamilyRelation from "./../familyRelation/searchFamilyRelation.vue";
import searchWifeRelation from "./../wifeRelation/searchWifeRelation.vue";
import searchFreeCourse from "../freeCourse/searchFreeCourse.vue";
import quoteInfo from "../quota/quoteInfo.vue";
import personFinancial from "../person_financial/personFinancial.vue";
import searchInquiry from "../inquiry/searchInquiry";
import attachmentPersonSpecial from "../attachmentPersonSpecial/attachmentPersonSpecial";
import searchTeachingExperience from "../teaching-experience/searchTeachingExperience.vue";
import personTags from "../personTags/index";
import { pathOr, includes } from "ramda";
import {
  generateCurrentRoute,
  generateStoreGetters,
  isAdmin,
} from "@/shared/utils";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import searchYearsOfService from "../yearsOfService/searchYearsOfService.vue";
import { mapGetters } from "vuex";

export default {
  name: "person-page",
  inject: [
    "profileRepository",
    "permissionGroupResourceRepository",
    "personHasDataRepository",
  ],
  components: {
    searchWifeRelation,
    searchFamilyRelation,
    editPerson,
    searchContact,
    searchWorkExperience,
    searchLicensePerson,
    skillsPage,
    searchFreeCourse,
    quoteInfo,
    searchEducation,
    searchArticels,
    searchAddress,
    searchSocialPerson,
    PersonHasData,
    searchPersonCompany,
    uploadFile,
    otherPersonPage,
    searchPersonExam,
    personFinancial,
    searchInquiry,
    attachmentPersonSpecial,
    personTags,
    LoadingSpinner,
    searchYearsOfService,
    searchTeachingExperience,
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      personCode:
        generateCurrentRoute(["params", "code"]) ||
        generateStoreGetters(["userInfo", "person", "code"]),
      isLoading: false,
      personItem: null,
      tabs_options: [],
      permissions: [],
      allowPermissions: ["admin", "edit"],
      showPermissionButton: false,
      tabPermissions: [],
      currentTab: this.$route.params.target || "editPerson",
      tabName: this.$route.params.target,
      tabLoading: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    showFilePreview() {
      /* guidance: don't show file preview detail when show my profile  */
      return this.$route.name !== "profile";
    },
  },
  watch: {
    $route(data) {
      const tabName = pathOr(null, ["params", "target"], data);
      this.setCurrentTab(tabName);

      // fetch first tab data when not fetched old time
      if (!this.personItem && !this.isLoading) {
        this.fetchData();
      }
    },
    personCode: {
      immediate: true,
      handler(val) {
        if (val) {
          this.generateData();
        }
      },
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    async updateTab(tab, has_data) {
      /* guidance: access update tab just for admin and edit */
      if (!isAdmin(this.tabPermissions)) {
        return this.$notify.warning(
          "شما دسترسی لازم را برای تغییر این گزینه ندارید"
        );
      }

      try {
        this.isLoading = true;
        let params = {
          tab_name: tab.value,
          has_data: has_data,
        };
        await this.personHasDataRepository.find(this.personCode, params);
        tab.show_tabs = has_data;
        tab.has_data = has_data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    activeTab(tabName) {
      this.setCurrentTab(tabName);
      /* guidance: push  dynamic tab name to end of url*/

      const params = {
        code: this.personCode,
        target: tabName,
      };
      this.$router
        .push({
          name: this.$route.name,
          params,
        })
        .catch(() => {});
    },
    setCurrentTab(tabName) {
      this.currentTab = tabName;
    },
    PermissionButtons() {
      this.showPermissionButton = this.permissions.some((item) =>
        includes(item, this.allowPermissions)
      );
    },
    async getTabs() {
      try {
        this.tabLoading = true;
        const serviceKey =
          generateCurrentRoute() === "profile" ? "profile" : "person";
        const params = { person_code: this.personCode };
        const response = await this.permissionGroupResourceRepository.list(
          serviceKey,
          params
        );

        const data = pathOr([], ["data", "data"], response);
        this.tabPermissions = response.data.permissions;

        this.tabs_options = [];
        this.tabs_options.push({
          text: "ویرایش اطلاعات فردی",
          value: "editPerson",
          show_tabs: true,
          has_data: true,
        });
        data.map((x) => {
          this.tabs_options.push({
            text: x.caption,
            value: x.id,
            has_data: x.has_data,
            show_check: includes(x.has_data, [true, false, null]),
            show_tabs: includes(x.has_data, [true, undefined]),
          });
        });
      } catch (errors) {
        this.$generateError(errors);
      } finally {
        this.tabLoading = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const activeTabName = this.getActiveTabInUrl();
        this.activeTab(activeTabName);
        const response = await this.profileRepository.list(this.personCode);
        this.personItem = pathOr(null, ["data", "data"], response);
        this.permissions = response.data.permissions;
        this.status = this.$lang.pending;
        this.PermissionButtons();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    getActiveTabInUrl() {
      const allTabs = this.tabs_options.map((tab) => tab.value);
      const pathname = window.location.pathname.split("/");
      const activeComponentName = pathname[pathname.length - 1];
      const activeTabName = includes(activeComponentName, allTabs)
        ? activeComponentName
        : "editPerson";
      return activeTabName;
    },
    async generateData() {
      await this.getTabs();
      if (this.currentTab === "editPerson") {
        await this.fetchData();
      }
    },
  },
};
</script>
